export default __webpack_public_path__ + "static/media/no-delete-agency.cb77a9fe.svg";